import { type FC } from 'react';

import { MainPageLayout } from '#apps/client-web/app/components/main-page-layout';

import { type AuditListPageViewModelProps } from './types';
import { AuditListPageContent } from './audit-list-page-content';

export type AuditListPageProps = AuditListPageViewModelProps;

export const AuditListPage: FC<AuditListPageProps> = ({ useViewModel }) => (
  <MainPageLayout title="Audits" pageContentProps={{ maxWidth: 'md' }}>
    <AuditListPageContent useViewModel={useViewModel} />
  </MainPageLayout>
);

export default AuditListPage;
